module.exports = __webpack_public_path__ + "img/HeadLogo.d00497ec.png";